
<h5>Alert Profile: <span class="psName">{{data.message[0].alertProfile}}</span></h5>
  <div class="wrapper">
    <mat-nav-list>
        <div *ngFor="let thresholddata of data.message;">
            <span><b>Datatype: </b>
                <span *ngIf="thresholddata.telemetryDataType == 'Battery_voltage'">Battert Voltage</span>
                <span *ngIf="thresholddata.telemetryDataType == 'in_voltage'">Input Voltage</span>
                <span *ngIf="thresholddata.telemetryDataType == 'out_current'">Output Current</span>
                <span *ngIf="thresholddata.telemetryDataType == 'out_power'">Output Power</span>
                <span *ngIf="thresholddata.telemetryDataType == 'out_voltage'">Output Voltage</span>
                <span *ngIf="thresholddata.telemetryDataType == 'temperature'">Temperature</span>
                <span *ngIf="thresholddata.telemetryDataType == 'total_string_voltage'">Total String Voltage</span>
            </span><br>
            <span><b>Min Value: </b>{{thresholddata.minValue}}</span><br>
            <span mat-list-item><b>Max Value: </b>{{thresholddata.maxValue}}</span><br>
            <span mat-list-item><b>Alert Low Value: </b>{{thresholddata.alertLowValue}}</span><br>
            <span mat-list-item><b>Alert High Value: </b>{{thresholddata.alertHighValue}}</span><br>
            <span mat-list-item><b>Warning Low Value: </b>{{thresholddata.warningLowValue}}</span><br>
            <span mat-list-item><b>Warning High Value: </b>{{thresholddata.warningHighValue}}</span><br><br>
            <div class="block_line" color="accent"></div>
        </div><br>
    </mat-nav-list>

</div>
<div class="d-flex justify-content-center">
    <mat-dialog-actions>
        <button mat-button mat-raised-button type="button" (click)="dialogRef.close()">Ok</button>
    </mat-dialog-actions>
</div>
